module.exports = __webpack_public_path__ + "static/media/BH202510.6b164cde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/BH202510.jpg
// module id = 332
// module chunks = 0